import { getLocale } from "../../i18n";

export default function toLocaleDateStringPadded(date: Date): string {
  return date.toLocaleDateString(getLocale(), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
